export function* waitPromise(obj, props) {
  return new Promise(function(resolve, reject) {
    ;(function waitForFoo() {
      let result = true
      props.map(prop => {
        if (obj.hasOwnProperty(prop)) {
          result = result && obj[prop]
        } else {
          result = false
        }
      })
      if (result) return resolve(obj)
      setTimeout(waitForFoo, 1000, { obj, props })
    })()
  })
}
